const config = {
  base_url: `${process.env.VUE_APP_API_BASE_URL}/api/v1`,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
};

export default config;
